import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { SessionticketsService } from 'src/app/shared/services/sessiontickets.service';
import { NgForm,FormsModule } from '@angular/forms';
import { Router,NavigationEnd,ActivatedRoute } from '@angular/router';
declare  var jQuery:  any;
import * as moment from  'moment';

@Component({
  selector: 'app-sessiontickets',
  templateUrl: './sessiontickets.component.html',
  styleUrls: ['./sessiontickets.component.scss']
})
export class SessionticketsComponent implements OnInit {

	is_authenticate_user: boolean = false;
  	hcontactRequest: any= {};
  	hcontactError: any;
  	hcontactSuccess: any;
  	seasonList: any = "";
    cartRequest: any = {};
  constructor(
  	public authService: AuthService,
    public sessionticketsService: SessionticketsService,
    private router: Router,
    ) { }

  ngOnInit() {
      this.sessionticketsService.getSeasonticket().then((data) => {
        this.seasonList = data.data[0];
        console.log(this.seasonList);
         setTimeout(function(){

        jQuery("#minus_btn").click(function(){          
            var qtyval = jQuery("#quantity").val();
            if(qtyval > 1)
            {
              qtyval = parseInt(qtyval) - 1;
              jQuery("#quantity").val(qtyval);
            }
          });
          jQuery("#plus_btn").click(function(){
            var qtyval = jQuery("#quantity").val();
            qtyval = parseInt(qtyval) + 1;
            jQuery("#quantity").val(qtyval);
          });

          jQuery(".increment-quantity").click((e)=>{
            var dataid = e.currentTarget.id;
            var qtyval = jQuery("#quantity"+dataid).val();
            var prival = jQuery("#price"+dataid).val();

            qtyval = parseInt(qtyval) + 1;
            jQuery("#quantity"+dataid).val(qtyval);
            this.generalCount = true;
            this.generaladAdult = jQuery('#pNos'+dataid).html(qtyval+' Nos.'); 
            this.generaladAdultvalue  = jQuery('#pPrice'+dataid).html('£'+qtyval*prival+'.00');
          });
          jQuery(".decrement-quantity").click(function(){
            var dataid = jQuery(this).attr('id');
            var qtyval = jQuery("#quantity"+dataid).val();
            var prival = jQuery("#price"+dataid).val();
            if(qtyval > 1)
            {
              qtyval = parseInt(qtyval) - 1;
              jQuery("#quantity"+dataid).val(qtyval);
              this.generaladAdultCount = qtyval;
              this.generaladAdult = jQuery('#pNos'+dataid).html(qtyval+' Nos.'); 
              this.generaladAdultvalue  = jQuery('#pPrice'+dataid).html('£'+qtyval*prival+'.00');
            }
          });
      },1000);

      
        
      });

     
      
      
  }

  add_to_cart(){
    if(this.authService.isLoggedIn == true)
    {
      this.is_authenticate_user = true;

      var finalvalue = "";
      var finalid = "";

      jQuery('.increment-quantity').each(function(){
            var dataid = jQuery(this).attr('id');
            var qtyval = jQuery("#quantity"+dataid).val();
            if(qtyval > 0){
              finalvalue = finalvalue + qtyval+',';
              finalid = finalid + dataid+',';
              //console.log(finalvalue);
            }
            
        });
        finalvalue = finalvalue.replace(/,(?=\s*$)/, ''); 
            finalid = finalid.replace(/,(?=\s*$)/, '');
      this.cartRequest = {
        type: "Season Tickets",
        seasonticket_detail_id: finalid,
        quantity: finalvalue
      };
      let request:any = { 
      };
      request = Object.assign({}, this.cartRequest);
      this.authService.getUsercart(request).then(
        (res) => {
        jQuery("#addtocart").removeClass("show");
            jQuery("#addtocart").addClass("hidden");
            
            jQuery("#gototcart").removeClass("hidden");
            jQuery("#gototcart").addClass("show");
       
          //console.log(res.data);
          /*this.addedtocartPopup();*/
          
          //this.loadcart();
        }).catch((err) => {
          //console.log(err);
        });
        jQuery(".checkout-center-detail-code-voucher a").click(function(){
          jQuery(".checkout-center-detail-code-box").addClass("intro");
        });
      }else{
        this.router.navigate(['/singin']);
      }
    
  }



}
